import { render, staticRenderFns } from "./PanelHeaderBackArrow.vue?vue&type=template&id=2ad10daa&scoped=true&"
import script from "./PanelHeaderBackArrow.vue?vue&type=script&lang=js&"
export * from "./PanelHeaderBackArrow.vue?vue&type=script&lang=js&"
import style0 from "./PanelHeaderBackArrow.vue?vue&type=style&index=0&id=2ad10daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad10daa",
  null
  
)

export default component.exports